/**
 * 密码验证
 *
 * @param { string } password - 密码
 *
 * @return { boolean }
 */
export const password = (password) => {
	return password.match(/^.{6,16}$/g) !== null;
};
